import { formatDate, formatTime, formatSquadInfo } from "../../../components/UI/DesignStandards";
import { FaClock, FaCheck, FaBan } from "react-icons/fa";

/**
 * Get the badge variant for a signup status
 * @param {string} status - Signup status
 * @returns {string} Badge variant
 */
export const getStatusBadgeVariant = (status) => {
  switch (status) {
    case "waitlisted":
      return "warning";
    case "approved":
    case "held":
      return "success";
    case "cancelled":
      return "default";
    default:
      return "default";
  }
};

/**
 * Get the icon for a signup status
 * @param {string} status - Signup status
 * @returns {JSX.Element} Status icon
 */
export const getStatusIcon = (status) => {
  switch (status) {
    case "waitlisted":
      return <FaClock className="w-4 h-4" />;
    case "approved":
    case "held":
      return <FaCheck className="w-4 h-4" />;
    case "cancelled":
      return <FaBan className="w-4 h-4" />;
    default:
      return <FaClock className="w-4 h-4" />;
  }
};

/**
 * Format squad time information
 * @param {Object} squad - Squad object with squadDate and squadTime
 * @returns {string} Formatted squad time string
 */
export const formatSquadTime = (squad) => {
  if (!squad) return "Not specified";
  
  // Use design standards formatSquadInfo which handles both date and time formatting
  // It uses formatDate (long format) and formatTime (12-hour format)
  if (squad.squadDate && squad.squadTime) {
    return formatSquadInfo(squad.squadDate, squad.squadTime);
  }
  
  // Fallback for missing date or time
  const dateStr = squad.squadDate 
    ? formatDate(squad.squadDate) 
    : "Date TBD";
  const timeStr = squad.squadTime 
    ? formatTime(squad.squadTime) 
    : "Time TBD";
  
  return `${dateStr} at ${timeStr}`;
};

/**
 * Format bowler names into a comma-separated string
 * @param {Array} bowlers - Array of bowler objects with name property
 * @returns {string} Comma-separated bowler names
 */
export const formatBowlerNames = (bowlers) => {
  if (!bowlers || bowlers.length === 0) return "No bowlers";
  return bowlers.map((b) => b.name).join(", ");
};

